<ng-container>
  <div class="menu-container" [class.menu-container-computer]="!contentMobile()">
    <a [title]="siteName()" class="menu-logo" [routerLink]="['/']">
      <img src="/img/new_logo.jpeg" [alt]="siteName()" />
    </a>

    <div
      class="menu-items"
      [class.menu-items-mobile]="contentMobile()"
      [class.menu-items-computer]="!contentMobile()"
      [class.menu-items-open]="menuOpen()"
    >
      @for (item of localItems(); track $index) {
        @if (item.link) {
          <span
            class="menu-item"
            [class.menu-item-activated]="item.activated()"
            [class.menu-item-mobile]="contentMobile()"
            [class.menu-item-computer]="!contentMobile()"
          >
              <a
                [routerLink]="[item.link]"
                [title]="item.label | trans"
                class="menu-item-label"
              >
                {{ item.label | trans }}
              </a>
            </span>
        } @else {
          <span
            class="menu-item"
            [class.menu-item-hidden]="item.isHidden()"
            [class.menu-item-activated]="item.activated()"
            [class.menu-item-mobile]="contentMobile()"
            [class.menu-item-computer]="!contentMobile()"
            (pointerenter)="toggleSubMenuByFocus($event, item, true)"
            (pointerleave)="toggleSubMenuByFocus($event, item, false)"
          >
              <span
                [title]="item.label | trans"
                class="menu-item-label"
                (click)="toggleSubMenu($event, item)"
              >
                {{ item.label | trans }}

                @if (contentMobile()) {
                  <span class="menu-item-label-icon">
                    <fa-icon [icon]="icons['chevronRight']" />
                  </span>
                }
              </span>

              <span
                class="menu-sub-items"
                [class.menu-sub-items-visible]="item.subItemsVisible()"
                [class.menu-sub-items-mobile]="contentMobile()"
                [class.menu-sub-items-computer]="!contentMobile()"
              >
                <span
                  class="menu-sub-items-core"
                  [class.menu-sub-items-core-computer]="!contentMobile()"
                >
                  <span
                    [title]="item.subLabel | trans"
                    class="menu-sub-items-title"
                    (click)="toggleSubMenu($event, item)"
                  >
                    @if (contentMobile()) {
                      <fa-icon [icon]="icons['arrowLeft']" />
                    }

                    {{ item.subLabel | trans }}
                  </span>

                  <span class="menu-sub-items-content">
                    @for (subItem of item.items(); track $index) {
                      @if (item.name === 'solutions') {
                        <solution-category-menu-card [category]="subItem" />
                      } @else {
                        <service-category-menu-card [category]="subItem" />
                      }
                    }
                  </span>
                </span>
              </span>
            </span>
        }
      }
    </div>

    @if (contentMobile()) {
      <button class="menu-burger" (click)="toggleMenu()">
        <fa-icon [icon]="localIcon()" />
      </button>
    }
  </div>
</ng-container>
